/**
 * Normalizes Venus AdvancedFilters searchOption values for backward compatibility.
 * Handles numeric and string values and falls back to 'all'.
 *
 * @param {Object|string|number} searchOption - Raw search option from Venus or config
 * @param {Object} aliases - Alias map from normalized raw value to canonical option
 * @returns {string} Normalized search option value
 */
export function normalizeSearchOption(searchOption, aliases = {}) {
    const rawValue = searchOption?.value ?? searchOption;
    const normalized = (rawValue ?? '').toString().trim().toLowerCase();

    return aliases[normalized] ?? 'all';
}

/**
 * Normalizes a search option specifically for System filters.
 * Maps: All (0), ID (1), Name (2), Owner (3)
 *
 * @param {Object|string|number} searchOption - Raw search option from Venus or config
 * @returns {string} Normalized system search option value
 */
export function normalizeSystemSearchOption(searchOption) {
    return normalizeSearchOption(searchOption, {
        0: 'all',
        1: 'id',
        2: 'name',
        3: 'owner',
        all: 'all',
        id: 'id',
        name: 'name',
        owner: 'owner',
    });
}

/**
 * Normalizes a search option specifically for User filters.
 * Maps: All (0), ID (1), Name (2), Email (3), Manager (4)
 *
 * @param {Object|string|number} searchOption - Raw search option from Venus or config
 * @returns {string} Normalized user search option value
 */
export function normalizeUserSearchOption(searchOption) {
    return normalizeSearchOption(searchOption, {
        0: 'all',
        1: 'id',
        2: 'name',
        3: 'email',
        4: 'manager',
        all: 'all',
        id: 'id',
        name: 'name',
        email: 'email',
        manager: 'manager',
    });
}
